<template>
  <section class="page-container">
    <el-dialog title="操作记录" :visible.sync="visible" width="80%">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <!--
          <el-form-item>
            <el-input v-model="filters.name" placeholder="名称"></el-input>
          </el-form-item>
          -->
          <el-form-item>
            <el-button type="primary" @click="list">Refresh</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="handleAdd">新增</el-button>
          </el-form-item> -->
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="results"
          highlight-current-row
          border
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <!-- <el-table-column prop="type" label="type"></el-table-column> -->
          <el-table-column prop="orderId" label="OrderID"></el-table-column>
          <el-table-column prop="statusEn" label="Status"></el-table-column>
          <el-table-column prop="image" label="Image">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.image"
                :src="scope.row.image"
                :preview-src-list="[scope.row.image]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="memo" label="Remark"></el-table-column>
          <el-table-column prop="createUserName" label="Operator"></el-table-column>
          <el-table-column prop="createTime" label="Operate time"></el-table-column>
          <!--
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-dropdown type="primary" @command="handleCommand">
                <el-button type="primary" size="mini">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{ type: 'edit', index: scope.$index, data: scope.row }"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{ type: 'delete', index: scope.$index, data: scope.row }"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          -->
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="type">
          <el-input v-model="addForm.type"></el-input>
        </el-form-item>
        <el-form-item label="orderId">
          <el-input v-model="addForm.orderId"></el-input>
        </el-form-item>
        <el-form-item label="status">
          <el-input v-model="addForm.status"></el-input>
        </el-form-item>
        <el-form-item label="image">
          <el-input v-model="addForm.image"></el-input>
        </el-form-item>
        <el-form-item label="memo">
          <el-input v-model="addForm.memo"></el-input>
        </el-form-item>
        <el-form-item label="createUserId">
          <el-input v-model="addForm.createUserId"></el-input>
        </el-form-item>
        <el-form-item label="createTime">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="type">
          <el-input v-model="editForm.type"></el-input>
        </el-form-item>
        <el-form-item label="orderId">
          <el-input v-model="editForm.orderId"></el-input>
        </el-form-item>
        <el-form-item label="status">
          <el-input v-model="editForm.status"></el-input>
        </el-form-item>
        <el-form-item label="image">
          <el-input v-model="editForm.image"></el-input>
        </el-form-item>
        <el-form-item label="memo">
          <el-input v-model="editForm.memo"></el-input>
        </el-form-item>
        <el-form-item label="createUserId">
          <el-input v-model="editForm.createUserId"></el-input>
        </el-form-item>
        <el-form-item label="createTime">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "OrderUpdateRecord",
  components: { MyPagination },
  props: {
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    // mainHeight(this);
    // this.list();
  },
  methods: {
    async show(orderId) {
      this.results = [];
      this.filters.orderId = orderId;
      this.visible = true;
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
        type: this.type,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/order-update-record/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/order-update-record/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/order-update-record/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/order-update-record/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete("mall:/api/admin/order-update-record/" + row.id)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
